<template>
    <div>
        <div v-if="info.product_class!=13">
            <address-card
                    :p_name="login_user.name"
                    :p_mobile="login_user.mobile"
                    :p_address="login_user.address_full"
                    @onClick="address_card_click"
            />
        </div>
        <div class="panel">
            <div class="logo"><img src="../../assets/mtsj-logo.png" /></div>
            <div class="title" v-if="info.made_type==1">梅唐四季自产</div>
            <div class="title" v-if="info.made_type==2">梅唐四季精选</div>
            <van-divider style="margin: 5px auto;" />
            <div class="pd-name">{{info.name}}</div>
            <div class="pd-notice">具体参见商品详情页</div>
        </div>
        <div class="price-banner">
            <div class="left-price">
                <span class="price-label">单价</span>
                <span class="price-code">￥</span>
                <span class="price">{{final_price}}</span>
                <span class="price-origin">￥{{info.origin_price}}</span>
            </div>
            <div class="right-price">
                <van-stepper v-model="order_qty" :min="info.moq" />
            </div>
        </div>

        <div class="price-banner" v-if="info.product_class==12">
            <div class="left-price">
                <span class="price-label">运费</span>
                <span class="price-code">￥</span>
                <span class="price">{{fare_sum}}</span>
            </div>
        </div>

        <div class="price-banner" v-if="coupon_sum>0">
            <div class="left-price">
                <span class="price-label">优惠券</span>
                <span class="price-code">￥</span>
                <span class="price"> - {{coupon_sum}}</span>
            </div>
        </div>

        <product-part-four :product_id="product_id" />

        <van-submit-bar :price="totalMoney" :loading="submit_loading" button-text="立即支付" @submit="onSubmit" />

<!--        用户地址录入-->
        <van-popup v-model="show_edit_address" style="width: 90%;height: 90%">
            <div>
                <van-address-edit
                        :close-on-click-overlay="false"
                        :closeable="true"
                        :show-postal="false"
                        :show-delete="false"
                        show-set-default
                        show-search-result
                        :area-list="areaList"
                        :area-columns-placeholder="['请选择', '请选择', '请选择']"
                        @save="onUserAddressSave"
                />
            </div>
        </van-popup>
    </div>
</template>

<script>
    import AddressCard from "../../components/Order/AddressCard";
    import AreaList from '@/libs/area';
    import AreaListHangzhou from '@/libs/area_hangzhou';
    import AreaListJZHW from '@/libs/area_jzhw';
    import { mapActions } from 'vuex';
    import ProductPartFour from "../../components/Product/ProductPartFour";

    export default {
        name: "CreateOrder",
        components: {ProductPartFour, AddressCard},
        data(){
            return {
                product_id:this.$route.params.product_id,
                sales_uid:this.$route.params.sales_uid,     //渠道id（系统中的uid）
                coupon_id:this.$route.params.coupon_id,     //优惠券id
                final_price:this.$route.params.price,       //外部传入价格，可能为空
                buy_mode:this.$route.params.buy_mode,       //购买模式：1普通；2优惠直购；3拼团购买
                group_id:this.$route.params.group_id,       //拼团记录id（可能为空）
                rule_id:this.$route.params.rule_id,         //拼团配置id（可能为空）
                lock_area:this.$route.params.lock_area,     //是否锁定配送区域
                areaList:this.$route.params.lock_area>0?(this.$route.params.lock_area==1?AreaListHangzhou:AreaListJZHW):AreaList,
                info:{
                    product_class:0,
                },
                login_user:this.$store.getters.getLoginUser,
                order_qty:1,
                show_edit_address:false,
                submit_loading:false,
                new_sale_order_id:'',
                my_coupon:{},
            }
        },
        computed:{
            coupon_sum(){
                //优惠券
                if(this.my_coupon){
                    return this.my_coupon.money;
                }else{
                    return 0;
                }
            },
            fare_sum(){
                //运费
                console.log('计算运费-登录用户',this.login_user);
                if(this.info.id){
                    if(this.login_user.province!=''){
                        //判断是否包邮
                        console.log('计算运费-产品对象',this.info);
                        console.log('计算运费-包邮区',this.info.free_fare_area);
                        if(this.info.free_fare_area!=null && this.info.free_fare_area.indexOf(this.login_user.province)>=0){
                            return 0;   //在包邮区内的邮费设置为0
                        }else{
                            return this.info.fare*this.order_qty;
                        }
                    }else{
                        return this.info.fare*this.order_qty;
                    }
                }else{
                    console.log('---计算运费 - 产品还没加载好---');
                    return 0;
                }
            },
            totalMoney(){
                let total=this.order_qty*this.final_price;
                let final_money=parseFloat(total)+parseFloat(this.fare_sum)-parseFloat(this.coupon_sum);
                return final_money*100;  //由于SubmitBar组件中price单位是分，所以乘以100
            }
        },
        methods:{
            ...mapActions([
                'UpdateUserInfo',
                'GetProductPublishedInfo',
                'WeixinCreateOrder',
                'WeixinPayCheck',
                'GetTheProductUserCoupon',
            ]),
            loadData(){
                let product_id=this.product_id;
                // console.log('product_id=',product_id);
                this.GetProductPublishedInfo({product_id}).then(res=>{
                    this.info=res;
                    // console.log(this.info);
                    if(!this.final_price){
                        this.final_price=this.info.price;
                    }
                    // this.areaList=this.info.lock_area?AreaListHangzhou:AreaList;
                    //是否锁定配送区域（0全国，1杭州主城区，2江浙沪皖）
                    if(this.info.lock_area==1){
                        this.areaList=AreaListHangzhou;
                    }else if(this.info.lock_area==2){
                        this.areaList=AreaListJZHW;
                    }else{
                        this.areaList=AreaList;
                    }
                });

                //读取当前用户的优惠券，如果有则显示
                let uid=this.login_user.id;
                let coupon_id=this.coupon_id;
                this.GetTheProductUserCoupon({uid,product_id,coupon_id}).then(res=>{
                    this.my_coupon=res;
                })
            },
            address_card_click(){
                this.show_edit_address=true;
            },
            onUserAddressSave(val){
                // console.log('表单内容',val);
                let data = {
                    'id':this.login_user.id,
                    'province':val.province,
                    'city':val.city,
                    'county':val.county,
                    'address':val.addressDetail,
                    'area_code':val.areaCode,
                    'name':val.name,
                    'mobile':val.tel,
                    'post_code':val.postalCode
                };
                this.UpdateUserInfo(data).then(res=>{
                    if(res.status>0){
                        this.$toast.fail('系统繁忙，请刷新重试！');
                    }else{
                        this.login_user.name=val.name;
                        this.login_user.mobile=val.tel;
                        this.login_user.address=val.addressDetail;
                        this.login_user.address_full=val.province+val.city+val.county+val.addressDetail;
                        this.login_user.province=val.province;
                        this.login_user.city=val.city;
                        this.login_user.county=val.county;
                        this.login_user.area_code=val.area_code;
                        this.login_user.post_code=val.post_code;
                        this.$store.commit('setUser',this.login_user);
                        this.show_edit_address=false;
                    }
                });
            },
            onSubmit(){
                //提交订单
                // console.log('用户对象：',this.login_user);
                if(!this.login_user||!this.login_user.id){
                    this.$toast.fail('请先授权微信登录系统！');
                    return;
                }
                if(this.info.product_class!=13 && !this.login_user.mobile && !this.login_user.address){
                    this.$toast.fail('请先填写收货人信息！');
                    return;
                }

                this.submit_loading=true;
                let details=[];
                details.push({
                    product_id:this.product_id,
                    order_qty:this.order_qty,
                    price:this.final_price,
                    commission:this.info.commission,
                    coupon_val:this.my_coupon?this.my_coupon.money:0,
                });
                //console.log('---- details 对象',details);
                let coupons=[];
                if(this.my_coupon){
                    coupons.push({
                        'user_coupon_id':this.my_coupon.id,
                        'coupon_money':this.my_coupon.money,
                        'product_id':this.my_coupon.product_id
                    });
                }

                let p={
                    mode:1,
                    client_uid:this.login_user.id,
                    openid:this.login_user.openid,
                    sales_uid:this.sales_uid,
                    product_name:this.info.name,
                    address:this.login_user.address,
                    province:this.login_user.province,
                    city:this.login_user.city,
                    county:this.login_user.county,
                    customer_name:this.login_user.name,
                    customer_tel:this.login_user.mobile,
                    buy_mode:this.buy_mode,
                    sale_group_id:this.group_id,
                    sale_group_rule_id:this.rule_id,
                    details,
                    fare_val:this.fare_sum,
                    coupons
                };
                this.WeixinCreateOrder(p).then(res=>{
                    if(res.status>0){
                        //失败
                        this.$toast.fail('订单创建失败！');
                        this.submit_loading=false;
                    }else{
                        //成功
                        // console.log('统一订单接口成功！');
                        // console.log(res.responseObject);
                        console.log('新订单id为',res.msg);
                        this.new_sale_order_id=res.msg.toString().split('|')[0];
                        this.group_id=res.msg.toString().split('|')[1];
                        this.weixinPay(res.responseObject);
                    }
                });

            },
            weixinPay(data){
                //调起微信支付
                var vm = this;
                if (typeof window.WeixinJSBridge == "undefined") {
                    if (document.addEventListener) {
                        document.addEventListener("WeixinJSBridgeReady",vm.onBridgeReady(data),false);
                    } else if (document.attachEvent) {
                        document.attachEvent("WeixinJSBridgeReady",vm.onBridgeReady(data));
                        document.attachEvent("onWeixinJSBridgeReady",vm.onBridgeReady(data));
                    }
                } else {
                    vm.onBridgeReady(data);
                }
            },
            onBridgeReady(data){
                let that = this;
                window.WeixinJSBridge.invoke(
                    "getBrandWCPayRequest",
                    data,
                    function(res) {
                        // console.log('----- onBridgeReady 进入------');
                        // console.log(res);
                        if(res.err_msg == "get_brand_wcpay_request:ok"){
                            //支付成功，到后台确认一下
                            let order_id=that.new_sale_order_id;
                            that.WeixinPayCheck({order_id}).then(res=>{
                                if(res.status>0){
                                    //支付服务端校验失败
                                    that.$toast.fail('订单支付状态校验失败，请稍候至我的订单查看!');
                                    //进入我的订单页面（暂时到这里）
                                    let product_id=that.product_id,sales_uid=that.sales_uid;
                                    that.$router.push({name:'ProductDetailSale',params:{product_id,sales_uid}});
                                }else{
                                    //支付校验成功，进入支付成功页面
                                    let product_id=that.product_id,sales_uid=that.sales_uid,
                                        buy_mode=that.buy_mode,group_id=that.group_id;
                                    that.$router.push({name:'OrderSuccess',
                                        params:{product_id,sales_uid,order_id,buy_mode,group_id}});
                                }
                            })
                        }else{
                            that.$toast.fail('订单支付失败,请到我的订单中重新支付!');
                            that.$router.push({name:'MyOrderClient'});
                        }
                    }
                );
            },
        },
        mounted() {
            document.body.style.backgroundColor='#F3F4F5';  //设置整页背景色
            this.loadData();
        }
    }
</script>

<style lang="scss" scoped>
    .panel{
        background-color: #FFFFFF;
        margin: 14px;
        text-align: left;
        padding-left: 14px;
        border-radius: 10px;
        .logo{
            display: inline-block;
            line-height: 30px;
            img{
                vertical-align: middle;
                width: 20px;
                height: 20px;
            }
        }
        .title{
            display: inline-block;
            font-size: 12px;
            color: #666666;
            font-weight: bold;
            padding-left: 5px;
        }
        .pd-name{
            font-size: 18px;
            padding: 4px 6px;
        }
        .pd-notice{
            font-size: 12px;
            color: #666666;
            padding: 4px 6px;
        }
    }
    .price-banner{
        background-color: #FFFFFF;
        margin: 14px;
        text-align: left;
        padding-left: 14px;
        border-radius: 10px;
        min-height: 50px;
        .left-price{
            display: inline-block;
            float: left;
            padding-left: 5px;
            padding-top: 10px;
            .price-label{
                font-size: 14px;
                color: #666666;
            }
            .price-code{
                font-size: 12px;
                color: #E34928;
            }
            .price{
                font-size: 20px;
                font-weight: bold;
                color: #E34928;
            }
            .price-origin{
                font-size: 12px;
                text-decoration:line-through;
                color: #666666;
                padding-left: 3px;
            }
        }
        .right-price{
            padding-top: 10px;
            padding-right: 8px;
            float: right;
        }
    }
</style>
